export default "__VITE_ASSET__a4d6a03f__"